import type { UserVerificationInitResponse } from './dto-verification'

export interface UserVerificationInitData {
    correlationId: string
    message: string
    status: string
    firstName: string
    lastName: string
    fullAddress: string
    fullName: string
}

/**
 * Maps UserVerificationInitResponse to the normalized UserVerificationInitData,
 * computing `fullName` as "firstName lastName". Replaces the former
 * UserVerificationInitData model class.
 */
export const toUserVerificationInitData = (
    data: UserVerificationInitResponse,
): UserVerificationInitData => ({
    correlationId: data.correlationId,
    message: data.message,
    status: data.status,
    firstName: data.firstName,
    lastName: data.lastName,
    fullAddress: data.fullAddress,
    fullName: `${data.firstName} ${data.lastName}`,
})
